import config from '../config';
import translate from '../helpers/i18n';

const lang = config.i18n.lang || 'ru';

export default {
  lang,
  t(path, values, defaultValue) {
    return translate(config.i18n.messages, path, values, defaultValue);
  },
};
